module.exports = __webpack_public_path__ + "img/timeline1.eb982677.png";